import React, { useRef, useState } from 'react';
import { Card } from 'primereact/card';
import { ErrorMessage, Formik, Form as FormFormik, Field } from 'formik';
import { Button } from 'primereact/button';
import { Messages } from 'primereact/messages';
import { ProgressSpinner } from 'primereact/progressspinner';
import Popup from 'reactjs-popup';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import { RadioButton } from 'primereact/radiobutton';
import { InputText } from 'primereact/inputtext';
import { Message } from '@material-ui/icons';
import { Fieldset } from 'primereact/fieldset';
import * as yup from 'yup';

import Visa from '../../assets/visa.png';
import MasterCard from '../../assets/mastercard.png';
import Elo from '../../assets/elo.png';
import Hipercard from '../../assets/hipercard.png';

import { showWarn, showInfo } from '../../modulos/messages';

import { enviarLinkAlteracaoCartao } from '../../services/assinaturas/index';
import DialogSuccess from '../dialogs/dialog-sucesso';

export default function TrocaCartao({ inscricao, associado, tipoCobranca, existsToken }) {
    const validations = yup.object().shape({});
    const messages = useRef(null);

    const [loading, setLoading] = useState('loading');
    const header = <img alt="Card" src={FundoAmarelo} />;
    const [sucesso, setSucesso] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const [celular, setCelular] = useState(null);
    const [email, setEmail] = useState(null);
    const [envio, setEnvio] = useState(null);
    const [tipo, setTipo] = useState(null);

    const planosLinkRecorrencia = ['ZP', 'ZP4', 'ZPA', 'ZPC'];

    const initialValues = {
        FormaEnvio: '',
        TipoAceite: ''
    };

    const handleSubmit = async (values, onSubmitOptions, close) => {
        setLoading('nada');
        values.Inscricao = inscricao;
        values.TipoAceite = envio;
        values.FormaEnvio = tipo;
        values.EmailEnvio = email;
        values.TelefoneEnvio = celular;
        values.referenciaCobranca = 'recorrente';
        values.StatusCobranca = 1;

        if (!envio || !tipo) {
            setLoading('loading');

            return showInfo(messages,'Verifique se as opções \'forma de envio\' e \'Tipo de envio\' estão marcadas ');
        }

        if (!email && tipo === 2) {
            setLoading('loading');

            return showInfo(messages,'Para concluir o envio do e-mail preencha o mesmo abaixo. ');
        }

        if (!celular && tipo === 1) {
            setLoading('loading');

            return showInfo(messages,'Para concluir o envio da mensagem por telefone, preencha o número do mesmo abaixo. ');
        }

        enviarLinkAlteracaoCartao(values)
            .then(response => {
                if (response.status === 400) {
                    setLoading('loading');
                    showWarn(messages,'Falha ao enviar o link de alteração do cartão de crédito.');
                } else if (response.status === 422) {
                    setLoading('loading');
                    showWarn(messages,'Falha ao enviar o link de alteração do cartão de crédito.');
                } else if (response.status === 500) {
                    setLoading('loading');
                    showWarn(messages,'Falha ao enviar o link de alteração do cartão de crédito.');
                }
                else if (response.data.message == 'Operação realizada com sucesso.') {
                    setOpenDialog(true);
                    close();
                } else {
                    setLoading('loading');
                    showWarn(messages,'Falha ao enviar o link de alteração do cartão de crédito.');
                }
            })
            .catch(() => {
                setLoading('loading');
                showWarn(messages,'Falha ao enviar o Aceite ');
            });
    };

    const exibeComponenteDiferenteDebitoEmConta = associado.Aceite.trim() === 'S' && 
                        planosLinkRecorrencia.includes(associado.SubGrupo.trim()) && 
                        associado.Status === 1 && 
                        tipoCobranca !== 5;
                        
    return (
        <>
            {exibeComponenteDiferenteDebitoEmConta && (
                <div >
                    <Popup
                        modal
                        trigger={
                            <Button
                                type="submit"
                                label="Enviar link recorrência"
                                className="p-button-info"
                            />
                        }
                    >
                        {close => (
                            <div className="modal">
                                <div className="content">
                                    <Card className='tratar-scroll-card' header={header} title="Alteração de cartão de credito">
                                        <div style={{ display: 'inline-block' }} >
                                            <Messages className='messageContent' ref={messages} />
                                        </div>
                                        {loading == 'loading' ? (
                                            <Formik
                                                onSubmit={(values, onSubmitOptions) => handleSubmit(values, onSubmitOptions, close)}
                                                initialValues={initialValues}
                                                validationSchema={validations}
                                            >
                                                {({
                                                    handleBlur,
                                                    handleChange,
                                                    handleSubmit,
                                                    values
                                                }) => (
                                                    <FormFormik className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                                        <div className=" p-col-6 p-md-6">
                                                            {sucesso && (
                                                                <Message
                                                                    severity="success"
                                                                    text="Enviado link para alteração."
                                                                />
                                                            )}

                                                        </div>

                                                        <Fieldset legend="Envio">
                                                            <div className="p-field p-grid">
                                                                <h2
                                                                    className="p-col-12 p-md-12 p-lg-12 p-sm-12"
                                                                    style={{ marginLeft: '10px' }}
                                                                >
                                  Tipo de Envio
                                                                </h2>
                                                                <>
                                                                    {!existsToken ? (
                                                                        <>
                                                                            <div className="p-field-checkbox p-col-12 p-md-6 p-lg-4 p-sm-3">
                                                                                <div
                                                                                    className="p-field p-grid"
                                                                                    style={{
                                                                                        marginBottom: '14px',
                                                                                        marginTop: '7px',
                                                                                        marginLeft: '15px'
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        className="img"
                                                                                        alt="visa"
                                                                                        src={Visa}
                                                                                        style={{
                                                                                            height: '3em',
                                                                                            width: '50px'
                                                                                        }}
                                                                                    />
                                                                                    <img
                                                                                        className="img"
                                                                                        alt="master"
                                                                                        src={MasterCard}
                                                                                        style={{
                                                                                            height: '30%',
                                                                                            width: '50px'
                                                                                        }}
                                                                                    />
                                                                                    <img
                                                                                        className="img"
                                                                                        alt="elo"
                                                                                        src={Elo}
                                                                                        style={{
                                                                                            height: '2.5em',
                                                                                            width: '50px'
                                                                                        }}
                                                                                    />
                                                                                    <img
                                                                                        className="img"
                                                                                        alt="hiper"
                                                                                        src={Hipercard}
                                                                                        style={{
                                                                                            height: '2.5em',
                                                                                            width: '50px'
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div
                                                                                    className="p-field p-grid"
                                                                                    style={{
                                                                                        marginLeft: '13px',
                                                                                        marginTop: '30px'
                                                                                    }}
                                                                                >
                                                                                    <Field
                                                                                        as={
                                                                                            RadioButton
                                                                                        }
                                                                                        inputId="recorrencia"
                                                                                        name="recorrencia"
                                                                                        value={3}
                                                                                        onChange={e => setEnvio(e.value)}
                                                                                        checked={envio === 3}
                                                                                    />
                                                                                    <label htmlFor="recorrencia">
                                            Alteração do cartão de crédito
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </>

                                                                {/* </div> */}

                                                                <h2 className="p-col-12 p-md-12 p-lg-12 p-sm-12"
                                                                    style={{
                                                                        marginBottom: '15px'
                                                                    }}>
                                  Forma de Envio
                                                                </h2>
                                                                <br />
                                                                <div className="p-field-checkbox p-col-12 p-md-6 p-lg-3 p-sm-3">
                                                                    <Field
                                                                        as={RadioButton}
                                                                        inputId="tipoEmail"
                                                                        name="tipoEmail"
                                                                        value={2}
                                                                        onChange={e => setTipo(e.value)}
                                                                        checked={tipo === 2}
                                                                    />
                                                                    <label htmlFor="tipoEmail">
                                    Email
                                                                    </label>
                                                                </div>
                                                                <div className="p-field-checkbox p-col-12 p-md-6 p-lg-5 p-sm-5">
                                                                    <Field
                                                                        as={RadioButton}
                                                                        inputId="tipoMsg"
                                                                        name="tipoMsg"
                                                                        value={1}
                                                                        onChange={e => setTipo(e.value)}
                                                                        checked={tipo === 1}
                                                                    />
                                                                    <label htmlFor="tipoMsg">
                                    Mensagem de texto
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <br />
                                                            <div className="p-grid p-fluid ">
                                                                <div className="p-col-12 p-md-8">
                                                                    <Field
                                                                        type="email"
                                                                        as={InputText}
                                                                        name="EmailEnvio"
                                                                        id="EmailEnvio"
                                                                        placeholder="Email"
                                                                        onChange={e => { setEmail(e.target.value); }}
                                                                    />
                                                                    <ErrorMessage
                                                                        component="span"
                                                                        name="EmailEnvio"
                                                                        style={{
                                                                            color: 'red'
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="p-col-12 p-md-8">
                                                                    <Field
                                                                        type="text"
                                                                        as={InputText}
                                                                        name="TelefoneEnvio"
                                                                        id="TelefoneEnvio"
                                                                        maxlength="11"
                                                                        placeholder="Numero Whatsapp ou para Msg"
                                                                        onChange={e => { setCelular(e.target.value); }}
                                                                    />
                                                                    <ErrorMessage
                                                                        component="span"
                                                                        name="TelefoneEnvio"
                                                                        style={{
                                                                            color: 'red'
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Fieldset>
                                                        <br />
                                                        <br />
                                                        <div className="p-grid p-fluid">
                                                            <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                                                <button
                                                                    type="submit"
                                                                    icon="pi pi-plus"
                                                                    className="btn-primary"
                                                                    onClick={handleSubmit}
                                                                >
                                  Enviar
                                                                </button>
                                                            </div>
                                                            <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                                                                <Button
                                                                    type="submit"
                                                                    label="Fechar"
                                                                    onClick={close}
                                                                />
                                                                <br />
                                                                <br />
                                                            </div>
                                                        </div>
                                                    </FormFormik>
                                                )}
                                            </Formik>
                                        ) : (
                                            <div className={loading}>
                                                <ProgressSpinner
                                                    style={{
                                                        width: '100px',
                                                        height: '100px'
                                                    }}
                                                    strokeWidth="1"
                                                    fill="#EEEEEE"
                                                    animationDuration=".5s"
                                                />
                                            </div>
                                        )}
                                    </Card>
                                </div>
                            </div>
                        )}
                    </Popup>

                    <DialogSuccess openDialog={openDialog} messageHeader='Link enviado com Sucesso!' messageBody='Link enviado com Sucesso!'/>
                </div>

            )}
        </>
    );
}
